import { cn } from "@/lib/utils";
import sketchaLogo from "@/assets/skecha-logo.png";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  showText?: boolean;
  onClick?: () => void;
}

const Logo = ({ size = "md", className, showText = true, onClick }: LogoProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8", 
    lg: "w-10 h-10",
    xl: "w-16 h-16"
  };

  const textSizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl", 
    xl: "text-3xl"
  };

  return (
    <div 
      className={cn(
        "flex items-center gap-2",
        onClick && "cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      <div className={cn(
        "overflow-hidden",
        sizeClasses[size]
      )}>
        <img 
          src={sketchaLogo} 
          alt="SKECHA Logo" 
          className="w-full h-full object-cover"
          width={1024}
          height={1024}
        />
      </div>
      {showText && (
        <span className={cn(
          "font-bold bg-gradient-hero bg-clip-text text-transparent",
          textSizeClasses[size]
        )}>
          SKECHA
        </span>
      )}
    </div>
  );
};

export default Logo;